export default "__VITE_ASSET__2l9mqBJ9__"